import { Component, OnInit, Input, Output,EventEmitter } from '@angular/core';
import { PaymentsService } from 'src/app/services/payments.service';
import { SimpleDataFilter } from 'src/app/models/simpleDataFilter';
import { ToastrService } from 'ngx-toastr';
import { PaymentMethod } from 'src/app/models/PaymentModels';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AssignPaymentMethodComponent } from '../assign-payment-method/assign-payment-method.component';
import { EditPaymentMethodComponent } from '../edit-payment-method/edit-payment-method.component';


@Component({
  selector: 'app-payment-method-list',
  templateUrl: './payment-method-list.component.html',
  styleUrls: ['./payment-method-list.component.less']
})
export class PaymentMethodListComponent implements OnInit {
  constructor(public paymentsService : PaymentsService, public toast: ToastrService, public modalService : NgbModal) { }
  @Input() selectEnabled : boolean;
  @Input() selectedMethodId : number;
  @Input() editEnabled : boolean;
  @Input() clientId : number;
  @Input() propertyId : number;
  @Output() pmtMethodSelectedEvt : EventEmitter<PaymentMethod> = new EventEmitter();

  ngOnInit() {
    //when loading the list, we use the claim to only pull the relevant pmt methods from the api
    this.paymentsService.LoadUserPaymentMethods(this.propertyId,this.clientId, this.selectedMethodId);
  }

  togglePmtSelect(pmt : PaymentMethod){
    this.paymentsService.paymentMethods.forEach(pmt => {pmt.selected = false;});
    pmt.selected = !pmt.selected;
    this.pmtMethodSelectedEvt.next(pmt);
  }

  editPayment(pmt : PaymentMethod) : void {
    const modalRef = this.modalService.open(EditPaymentMethodComponent, { centered: true, size: 'lg' });
    modalRef.componentInstance.name = 'EditPaymentModalComponent';
    modalRef.componentInstance._paymentMethod = pmt;
    modalRef.componentInstance.clientId = this.clientId;
  }

  public deletePayment(pmt : PaymentMethod) : void {
    this.paymentsService.DeletePaymentMethod(pmt);
  } 
}
